import { render, staticRenderFns } from "./Shequ.vue?vue&type=template&id=58dc823e&scoped=true"
import script from "./Shequ.vue?vue&type=script&lang=js"
export * from "./Shequ.vue?vue&type=script&lang=js"
import style0 from "./Shequ.vue?vue&type=style&index=0&id=58dc823e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc823e",
  null
  
)

export default component.exports